<!-- fakturapp/src/shared/dialogs/ksef-xml-viewer-dialog/ksef-xml-viewer-dialog.component.html -->

<div class="flex flex-col h-full">
    <!-- Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
        <div>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white">
                XML Faktury
            </h2>
            <p *ngIf="documentNumber" class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                Faktura: <span class="font-medium">{{ documentNumber }}</span>
            </p>
            <p *ngIf="ksefNumber" class="text-xs text-gray-500 dark:text-gray-500 mt-1">
                Numer KSeF: {{ ksefNumber }}
            </p>
        </div>
        <button 
            mat-icon-button 
            (click)="close()"
            [matTooltip]="'Zamknij'">
            <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-hidden p-6 flex flex-col">
        
        <!-- Loading State -->
        <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-12">
            <mat-spinner [diameter]="60"></mat-spinner>
            <p class="text-gray-600 dark:text-gray-400 mt-4">Ładowanie XML faktury...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="error && !isLoading" class="flex flex-col items-center justify-center py-12">
            <mat-icon 
                class="text-red-500 dark:text-red-400 mb-4"
                [svgIcon]="'tabler_outline:alert-circle'"
                style="width: 64px; height: 64px; font-size: 64px;">
            </mat-icon>
            <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Nie udało się załadować XML
            </h3>
            <p class="text-gray-600 dark:text-gray-400 text-center max-w-md">
                {{ error }}
            </p>
            <button 
                mat-stroked-button 
                color="primary"
                class="mt-4"
                (click)="loadXml()">
                Spróbuj ponownie
            </button>
        </div>

        <!-- XML Content -->
        <div *ngIf="!isLoading && !error" class="flex-1 flex flex-col">
            
            <!-- Actions Bar -->
            <div class="flex items-center justify-between mb-4 pb-3 border-b border-gray-200 dark:border-gray-700">
                <div class="text-sm text-gray-600 dark:text-gray-400">
                    Rozmiar: {{ (xml.length / 1024).toFixed(2) }} KB
                </div>
                <div class="flex gap-2">
                    <button 
                        mat-stroked-button 
                        (click)="copyToClipboard()"
                        [matTooltip]="'Kopiuj do schowka'">
                        <mat-icon [svgIcon]="'tabler_outline:copy'"></mat-icon>
                        Kopiuj
                    </button>
                    <button 
                        mat-stroked-button 
                        color="primary"
                        (click)="downloadXml()"
                        [matTooltip]="'Pobierz plik XML'">
                        <mat-icon [svgIcon]="'tabler_outline:download'"></mat-icon>
                        Pobierz
                    </button>
                </div>
            </div>

            <!-- XML Viewer with Syntax Highlighting -->
            <div class="xml-container bg-gray-900 rounded-lg flex-1">
                <textarea 
                    fakturnia-highlight
                    [code]="formattedXml"
                    [lang]="'xml'"
                    readonly>
                </textarea>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-3 p-6 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
        <button 
            mat-stroked-button 
            (click)="close()">
            Zamknij
        </button>
    </div>
</div>

